module.exports = __webpack_public_path__ + "krecove-zily_5_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/obecna-a-zilni-chirurgie/krecove-zily_5_before.jpg
// module id = 1034
// module chunks = 0